import React from 'react'
import PropTypes from 'prop-types'
import Loading from 'components/Loading'
import { getEmployeeId } from 'utils/getEmployeeId'
import FeatureToggleList from './components/FeatureToggleList'

const styles = Object.assign(
  {},
  require('./FeatureToggle.scss'),
  require('components/Table/Table.scss'),
  { columns: require('./columns.scss') },
)

class FeatureToggleView extends React.Component {
  static propTypes = {
    getFeatureToggles: PropTypes.func,
    editFeatureToggle: PropTypes.func.isRequired,
  }
  static defaultProps = {
    getFeatureToggles: null,
  }
  constructor(props) {
    super(props)
    this.handleInitFilteredData = this.handleInitFilteredData.bind(this)
  }

  handleInitFilteredData() {
    this.props.getFeatureToggles(getEmployeeId(this.props.selectedPartner, this.props.currentUser))
  }

  render() {
    const { featureToggle, editFeatureToggle } = this.props
    if (featureToggle.isFetching) {
      return (<Loading pageLoading />)
    }
    return (
      <div className={styles.content}>
        <section className={styles.section}>
          {featureToggle.fetched &&
          <FeatureToggleList
            editFeatureToggle={editFeatureToggle}
            featureToggleItems={featureToggle.items}
            header="Feature Toggles"
          />}
        </section>
      </div>
    )
  }
}

export default FeatureToggleView



// WEBPACK FOOTER //
// ./src/views/FeatureToggle/FeatureToggle.js